import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback } from 'react';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { useDeviceState } from 'console/shared/contexts/device/state';
import { useBoilerHeatingCircuit } from './provider';
import { ServiceBoilerHeatingCircuitCard } from './variants/service';
import { SimpleBoilerHeatingCircuitCard } from './variants/simple';
export const BoilerHeatingCircuitCard = memo(function BoilerHeatingCircuitCard(props) {
    const { onClick } = props;
    const { id } = useBoilerHeatingCircuit();
    const { is_service_mode } = useDeviceState();
    const nextUiGuide = useAppSelector((state) => state.ui_guide_state.store_helpers.next);
    const onCardClick = useCallback(() => {
        onClick(id);
        nextUiGuide?.();
    }, [id, nextUiGuide]);
    const Card = is_service_mode
        ? ServiceBoilerHeatingCircuitCard
        : SimpleBoilerHeatingCircuitCard;
    return _jsx(Card, { onClick: onCardClick });
});
